import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";
import i18next from "i18next";
import IconDefaultLocation from "../../../assets/iconDefaultLocation";
import ModalComponent from "../../commons/modalComponent";
import { useModal } from "../../../../application/utils/useModal";
import { findTranslation } from "../../../../infrastructure/i18n/findTranslation";
import { getUrlLocale } from "../../../../utils/getUrlLocale";
const CarDetailsReservation = ({ formData, myData, rate, t, shouldHide }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { isShown: isModal1Shown, toggle: toggleModal1 } = useModal();
    const { isShown: isModal2Shown, toggle: toggleModal2 } = useModal();
    const [zoom, setZoom] = useState(16);
    const [pickUpLocation, setPickUpLocation] = useState([]);
    const [pickUpAddress, setPickUpAddress] = useState({});
    const [returnLocation, setReturnLocation] = useState([]);
    const [returnAddress, setReturnAddress] = useState({});
    const [loading, setLoading] = useState(true);
    function capitalizeWords(str) {
        return str.replace(/\b\w/g, char => char.toUpperCase());
    }
    useEffect(() => {
        setPickUpLocation(myData.pickUpLocation);
        setReturnLocation(myData.returnLocation);
        setLoading(false);
    }, []);
    // WI #8320 — Same forEach + .includes() bug pattern as the search bar
    // pickers. Replace with `findTranslation` keyed off the URL locale so
    // the details/reservation card matches the URL language (not the
    // country-selector contaminated `i18next.language`).
    const checkTranlation = (location) => {
        var _a, _b;
        let nameTranslation = (_b = (_a = location === null || location === void 0 ? void 0 : location.name) !== null && _a !== void 0 ? _a : location === null || location === void 0 ? void 0 : location.description) !== null && _b !== void 0 ? _b : "";
        if (!Array.isArray(location === null || location === void 0 ? void 0 : location.translations)) {
            return nameTranslation;
        }
        const match = findTranslation(location.translations, getUrlLocale("lower"));
        if (match && typeof match.name === "string" && match.name.trim() !== "") {
            nameTranslation = match.name;
        }
        if (typeof nameTranslation === "string" && nameTranslation.length > 0) {
            return nameTranslation.charAt(0).toUpperCase() + nameTranslation.slice(1);
        }
        return "";
    };
    const formatDate = (inputDate) => {
        const date = new Date(inputDate);
        const locale = i18next.language || "en-US";
        const formattedDate = date.toLocaleDateString(locale, {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString(locale, {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
        return `${formattedDate} ${formattedTime}`;
    };
    const MyMapComponent = ({ centerAddress, type }) => {
        const mapRef = useRef(null);
        const markerRef = useRef(null);
        useEffect(() => {
            if (!mapRef.current)
                return;
            const customMapStyle = [
                {
                    featureType: "administrative",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "administrative.province",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 65,
                        },
                        {
                            visibility: "on",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: "50",
                        },
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "30",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "40",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            hue: "#ffff00",
                        },
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -97,
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -100,
                        },
                    ],
                },
            ];
            const map = new google.maps.Map(mapRef.current, {
                zoom,
                disableDefaultUI: true,
                zoomControl: true,
                styles: customMapStyle,
            });
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: centerAddress }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK &&
                    results &&
                    results.length > 0) {
                    const location = results[0].geometry.location.toJSON();
                    map.setCenter(location);
                    let svgData = type === 0
                        ? `<svg width="191" height="60" xmlns="http://www.w3.org/2000/svg">
              <g>
                <rect stroke="#002347" rx="20" id="svg_1" height="43" width="146" y="2" x="24" fill="#032347"/>
                <path transform="rotate(180 98.5 36.5955)" stroke="#002347" id="svg_3" d="m76,57.48289l22.5,-41.77486l22.5,41.77486l-45,0z" fill="#032347"/>
                <g transform="translate(45,16) scale(1)">
                  <path fillRule="evenodd" clipRule="evenodd" d="M18.6323 4.01715C18.4571 4.61589 17.9457 4.86536 17.4485 5.13653C17.0115 5.37515 13.6628 7.20028 13.6302 7.21547C13.5798 7.28009 13.5336 7.34796 13.4919 7.41866C13.4614 7.79395 13.0223 16.438 12.9712 16.5421C12.5435 16.8232 12.0859 17.0539 11.6072 17.2298C11.5313 17.1588 11.4777 17.0665 11.4533 16.9644L9.33878 9.82517C9.30594 9.75568 9.28004 9.68301 9.26146 9.60824C9.26146 9.60824 5.80352 11.5144 5.23109 11.7956C5.17098 11.8252 5.12247 11.8746 5.09348 11.9359C5.05014 11.9891 5.02346 12.0544 5.01688 12.1232C4.96581 12.3734 4.64377 14.1754 4.57213 14.4372C4.57424 14.5559 4.53644 14.6717 4.46502 14.7655C4.21609 14.955 3.93602 15.0977 3.63795 15.187C3.56702 15.1559 2.95842 12.4898 2.8577 11.9063C2.8044 11.6916 2.69278 11.4966 2.53567 11.3437C2.23846 11.0263 0.29279 8.92273 0.312651 8.83957C0.539411 8.64264 0.805739 8.49874 1.09291 8.418C1.30808 8.41834 1.52119 8.46081 1.72066 8.5431C1.98594 8.68772 3.36557 9.27705 3.55922 9.37106C3.61201 9.37126 3.66427 9.38181 3.71314 9.40215C3.74176 9.40494 3.77061 9.40068 3.79727 9.38973C3.82393 9.37879 3.84763 9.36147 3.86636 9.33924C4.53028 9.00589 7.94283 7.13665 7.94283 7.13665C7.64846 6.71941 3.1166 1.13773 3.1166 1.13773C3.05905 1.08062 3.02591 1.00266 3.02439 0.920796C3.43622 0.615337 3.88338 0.362757 4.35579 0.168762C4.48547 0.173589 4.61195 0.211104 4.72393 0.277952C5.16513 0.559241 12.1271 4.77786 12.1583 4.77786C12.1903 4.78675 12.2239 4.78716 12.2561 4.77906C12.2882 4.77096 12.3178 4.75462 12.3421 4.73159C13.5985 4.03354 15.0032 3.26801 16.5561 2.43499C16.8549 2.24699 17.2115 2.17864 17.5569 2.24316C17.9023 2.30767 18.2119 2.50047 18.4259 2.78425C18.549 2.96005 18.6315 3.1619 18.6674 3.37475C18.7032 3.5876 18.6915 3.80596 18.633 4.01354" fill="white"/>
                </g>
                <style type="text/css">
                  <![CDATA[
                    @import url('https://fonts.googleapis.com/css2?family=Open+Sans');
                    text {
                      font-family: 'Open Sans', sans-serif;
                    }
                  ]]>
                </style>
                <text transform="matrix(0.795579 0 0 0.657935 23.7227 10.0413)" stroke="null" font-weight="bold" text-anchor="start" font-family="Open Sans" font-size="18" id="svg_9" y="28" x="60" fill="#ffffff">${t("pickup")}</text>
              </g>
            </svg>`
                        : `<svg width="191" height="60" xmlns="http://www.w3.org/2000/svg">
              <g>
                <rect stroke="#002347" rx="20" id="svg_1" height="43" width="146" y="4" x="34" fill="#032347"/>
                <path transform="rotate(180 98.5 36.5955)" stroke="#002347" id="svg_3" d="m76,57.48289l22.5,-41.77486l22.5,41.77486l-45,0z" fill="#032347"/>
                <g transform="translate(50, 16) scale(1)">
                  <path fill-rule="evenodd" clipRule="evenodd" d="M18.6323 4.01715C18.4571 4.61589 17.9457 4.86536 17.4485 5.13653C17.0115 5.37515 13.6628 7.20028 13.6302 7.21547C13.5798 7.28009 13.5336 7.34796 13.4919 7.41866C13.4614 7.79395 13.0223 16.438 12.9712 16.5421C12.5435 16.8232 12.0859 17.0539 11.6072 17.2298C11.5313 17.1588 11.4777 17.0665 11.4533 16.9644L9.33878 9.82517C9.30594 9.75568 9.28004 9.68301 9.26146 9.60824C9.26146 9.60824 5.80352 11.5144 5.23109 11.7956C5.17098 11.8252 5.12247 11.8746 5.09348 11.9359C5.05014 11.9891 5.02346 12.0544 5.01688 12.1232C4.96581 12.3734 4.64377 14.1754 4.57213 14.4372C4.57424 14.5559 4.53644 14.6717 4.46502 14.7655C4.21609 14.955 3.93602 15.0977 3.63795 15.187C3.56702 15.1559 2.95842 12.4898 2.8577 11.9063C2.8044 11.6916 2.69278 11.4966 2.53567 11.3437C2.23846 11.0263 0.29279 8.92273 0.312651 8.83957C0.539411 8.64264 0.805739 8.49874 1.09291 8.418C1.30808 8.41834 1.52119 8.46081 1.72066 8.5431C1.98594 8.68772 3.36557 9.27705 3.55922 9.37106C3.61201 9.37126 3.66427 9.38181 3.71314 9.40215C3.74176 9.40494 3.77061 9.40068 3.79727 9.38973C3.82393 9.37879 3.84763 9.36147 3.86636 9.33924C4.53028 9.00589 7.94283 7.13665 7.94283 7.13665C7.64846 6.71941 3.1166 1.13773 3.1166 1.13773C3.05905 1.08062 3.02591 1.00266 3.02439 0.920796C3.43622 0.615337 3.88338 0.362757 4.35579 0.168762C4.48547 0.173589 4.61195 0.211104 4.72393 0.277952C5.16513 0.559241 12.1271 4.77786 12.1583 4.77786C12.1903 4.78675 12.2239 4.78716 12.2561 4.77906C12.2882 4.77096 12.3178 4.75462 12.3421 4.73159C13.5985 4.03354 15.0032 3.26801 16.5561 2.43499C16.8549 2.24699 17.2115 2.17864 17.5569 2.24316C17.9023 2.30767 18.2119 2.50047 18.4259 2.78425C18.549 2.96005 18.6315 3.1619 18.6674 3.37475C18.7032 3.5876 18.6915 3.80596 18.633 4.01354" fill="white"/>
                </g>
                <style type="text/css">
                  <![CDATA[
                    @import url('https://fonts.googleapis.com/css2?family=Open+Sans');
                    text {
                      font-family: 'Open Sans', sans-serif;
                    }
                  ]]>
                </style>
                <text transform="matrix(0.795579 0 0 0.657935 23.7227 10.0413)" stroke="null" font-weight="bold" text-anchor="start" font-family="Open Sans" font-size="18" id="svg_9" y="30" x="70" fill="#ffffff">${t("dropoff")}</text>
              </g>
            </svg>`;
                    const svgUrl = `data:image/svg+xml;base64,${btoa(svgData)}`;
                    // Create the custom marker
                    const customMarker = new google.maps.Marker({
                        position: location,
                        map: map,
                        icon: {
                            url: svgUrl,
                            anchor: new google.maps.Point(98.5, 36.5955), // Set the anchor point
                            origin: new google.maps.Point(0, 0), // Set the origin point
                        },
                    });
                    // Save the marker reference for later use
                    markerRef.current = customMarker;
                }
                else {
                    console.error("Geocoder failed due to: " + status);
                }
            });
        }, [centerAddress, type]);
        return _jsx("div", { ref: mapRef, style: { width: "100%", height: "100%" } });
    };
    if (loading === true) {
        return null;
    }
    else {
        return (_jsx(_Fragment, { children: _jsx("div", { className: "detail__locations", children: _jsxs("div", { className: "location-tabs", children: [_jsxs("div", { className: "location-tab", children: [_jsxs("div", { className: "location-heading", children: [shouldHide &&
                                            _jsx("img", { src: (_b = (_a = pickUpLocation.locationType) === null || _a === void 0 ? void 0 : _a.icon) !== null && _b !== void 0 ? _b : "", alt: "icon-start-resev", style: { width: "1.5rem", height: "1.5rem" } }), _jsx("h5", { children: t("location-pickup-title") }), _jsx("button", { id: "show-element", className: "location-showless mobile", onClick: toggleModal1, children: _jsx(IconDefaultLocation, {}) })] }), _jsx("p", { className: "location-text", children: _jsx("strong", { children: formatDate(formData.pickUpDate + "T" + formData.pickUpTime) }) }), _jsx("p", { className: "location-text location-text--cursor", onClick: toggleModal1, children: pickUpLocation.locationName }), _jsx("p", { className: "location-text location-text--cursor", onClick: toggleModal1, children: pickUpLocation.locationAddress }), _jsx(ModalComponent, { isShown: isModal1Shown, hide: toggleModal1, customClass: "modal__container--map-desktop", modalContent: _jsx(Wrapper, { apiKey: (_d = (_c = process.env.REACT_APP_GOOGLE_API_KEY) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "default-api-key", children: _jsx(MyMapComponent, { centerAddress: (pickUpLocation.locationAddress).toString(), type: 0 }) }) })] }), _jsxs("div", { className: "location-tab", children: [_jsxs("div", { className: "location-heading", children: [shouldHide && (_jsx("img", { src: (_f = (_e = returnLocation.locationType) === null || _e === void 0 ? void 0 : _e.icon) !== null && _f !== void 0 ? _f : "", alt: "icon-start-resev", style: { width: "1.5rem", height: "1.5rem" } })), _jsx("h5", { children: t("location-dropoff-title") }), _jsx("button", { id: "show-element2", className: "location-showless mobile", onClick: toggleModal2, children: _jsx(IconDefaultLocation, {}) })] }), _jsx("p", { className: "location-text", children: _jsx("strong", { children: formatDate(formData.dropOffDate + "T" + formData.dropOffTime) }) }), _jsx("p", { className: "location-text location-text--cursor", onClick: toggleModal2, children: returnLocation.locationName }), _jsx("p", { className: "location-text location-text--cursor", onClick: toggleModal2, children: returnLocation.locationAddress }), _jsx(ModalComponent, { isShown: isModal2Shown, hide: toggleModal2, customClass: "modal__container--map-desktop", modalContent: _jsx(Wrapper, { apiKey: (_h = (_g = process.env.REACT_APP_GOOGLE_API_KEY) === null || _g === void 0 ? void 0 : _g.toString()) !== null && _h !== void 0 ? _h : "default-api-key", children: _jsx(MyMapComponent, { centerAddress: returnLocation.locationAddress, type: 1 }) }) })] })] }) }) }));
    }
};
export default CarDetailsReservation;
